import { useSearchQuery } from 'academy-common-lib/__generated__/chirp/com/hubspot/userssearch/rpc/AppUsersSearch.hooks';
import PortalIdParser from 'PortalIdParser';
export const useIsUserInOwnHub = userId => {
  var _data$results;
  const {
    data,
    loading,
    error
  } = useSearchQuery({
    variables: {
      mustMatchUserIds: [userId],
      offset: 0,
      pageLength: 1,
      onlyConfirmedUsers: false,
      onlyVisibleUsers: false,
      onlyHubspotters: false,
      uniqueUserIds: false,
      includePartnerUsers: true,
      includeDeactivatedUsers: false
    },
    skip: !PortalIdParser.get()
  });
  const isUserInOwnHub = Boolean(data === null || data === void 0 || (_data$results = data.results) === null || _data$results === void 0 ? void 0 : _data$results.length);
  return {
    isUserInOwnHub,
    isUserInOwnHubLoading: loading,
    isUserInOwnHubError: error
  };
};